import React, { Fragment } from 'react';
import sad from '../../../assets/images/other-images/sad.png';
import { Container, Button, Media, Col } from "reactstrap";
import { BACK_TO_HOME_PAGE } from "../../../Constant";
import { H2, P } from '../../../AbstractElements';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../_helper/Auth/AuthProvider';

const Error404 = ({ resetErrorBoundary = () => {} }) => {
    const { userData } = useAuth();
    const navigate = useNavigate();

    const handleBackToHome = () => {
        resetErrorBoundary(); // Reset the error boundary state
        if (!userData) {
            navigate('/auth/login');
        } else if (userData.role === 'admin') {
            navigate('/dashboard');
        } else if (userData.role === 'user') {
            navigate('/app/home');
        } else {
            navigate('/');
        }
    };

    return (
        <Fragment>
            <div className="page-wrapper">
                <div className="error-wrapper">
                    <Container>
                        <Media body className="img-100" src={sad} alt="" />
                        <div className="error-heading text-center">
                            <H2 attrH2={{ className: "font-danger text-center" }}>{"404"}</H2>
                        </div>
                        <Col md="8 offset-md-2">
                            <P attrPara={{ className: "sub-content text-center" }}>{"Le lien que vous essayez d'accéder a expiré."}</P>
                        </Col>
                        <div className="text-center mt-3">
                            <Button color="danger-gradien" size='lg' onClick={handleBackToHome}>
                                {BACK_TO_HOME_PAGE}
                            </Button>
                        </div>
                    </Container>
                </div>
            </div>
        </Fragment>
    );
};

export default Error404;